import { Injectable, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { formatDate } from 'date-fns';

import { ChartSearchParams } from '@bookly/shared';

export interface ChartFilterKeys {
  [key: string]: FormGroup | FormControl;
}

export interface ChartFiltersFormModel {
  fromDate: FormControl<Date | null>;
  toDate: FormControl<Date | null>;
  weekNumber: FormControl<number | null>;
  month: FormControl<number | null>;
  year: FormControl<number | null>;
  quarter: FormControl<number | null>;
}
@Injectable({
  providedIn: 'root',
})
export class ChartFiltersService {
  readonly #fb = inject(FormBuilder);
  readonly #currentYear = new Date().getFullYear();

  readonly #filtersForm: FormGroup<ChartFiltersFormModel> = this.#fb.group({
    fromDate: this.#fb.control<Date | null>(null),
    toDate: this.#fb.control<Date | null>(null),
    weekNumber: this.#fb.control<number | null>(null),
    month: this.#fb.control<number | null>(null),
    year: this.#fb.control<number | null>(this.#currentYear),
    quarter: this.#fb.control<number | null>(null),
  });

  get filtersForm() {
    return this.#filtersForm;
  }

  public getSelectedFormData(): ChartSearchParams {
    const { fromDate, toDate, weekNumber, month, year, quarter } =
      this.#filtersForm.value;
    const params: ChartSearchParams = {};
    if (fromDate)
      params.fromDate = formatDate(fromDate, "yyyy-MM-dd'T'00:00:00+00:00");
    if (toDate)
      params.toDate = formatDate(toDate, "yyyy-MM-dd'T'00:00:00+00:00");
    if (weekNumber) params.weekNumber = weekNumber;
    if (month) params.month = month;
    if (year) params.year = year;
    if (quarter) params.quarter = quarter;
    return params;
  }
  public resetForm() {
    this.#filtersForm.reset({
      fromDate: null,
      toDate: null,
      weekNumber: null,
      month: null,
      year: this.#currentYear,
      quarter: null,
    });
  }
}
